var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wishcard-big", class: _vm.wishcardClasses },
    [
      _c("div", { staticClass: "wishcard-big__preview" }, [
        _c("div", { staticClass: "wishcard-preview" }, [
          _c("div", { staticClass: "thumbnail" }, [
            _vm.siteThumbnail && _vm.card.size.toLowerCase() === "big"
              ? _c("img", {
                  staticClass: "wishcard-preview__img",
                  attrs: {
                    src: _vm.siteThumbnail,
                    alt: _vm.$t("label.wishcard")
                  }
                })
              : _vm.hasThumbnailImage &&
                _vm.card.size.toLowerCase() === "funeral"
              ? _c("img", {
                  staticClass: "wishcard-preview__img",
                  attrs: {
                    src: _vm.card.thumbnail,
                    alt: _vm.$t("label.wishcard") + ": " + _vm.card.name
                  }
                })
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wishcard-big__inner-right" },
        [
          _c("h4", {
            staticClass: "wishcard-big__label",
            domProps: {
              textContent: _vm._s(_vm.$t("wishcard.inner_side.right") + ":")
            }
          }),
          _vm._v(" "),
          _c(
            "tg-wishcard-textarea",
            _vm._b(
              {
                attrs: {
                  "show-layered-image": true,
                  "show-default-placeholder": false
                },
                on: { validate: _vm.onValidate }
              },
              "tg-wishcard-textarea",
              Object.assign({}, _vm.$props, _vm.wishcardProps),
              false
            )
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }